import IllumioSupportUtils  from "../common/support_utils";

export class IllumioTrainingLanguageCourse {
    constructor() {
        console.debug(`[DEBUG] Invoked IllumioTrainingLanguageCourse.constructor()`);
        this.initializeLanguageIcons();
        this.initializeDefaultLanguageIcon();
    }

    initializeLanguageIcons() {
        const trainingCourselanguageIcons = document.getElementsByClassName('training-course-language-icon');
        console.debug(trainingCourselanguageIcons);
        for (const iconElement of trainingCourselanguageIcons) {
            iconElement.onclick = this.trainingCourseLanguageIconOnClickHandler.bind(this);
            console.debug(iconElement);
        }
    }

    initializeDefaultLanguageIcon() {
        const language = IllumioSupportUtils.getLanguage();

        if (language!='en') {
            document.querySelectorAll('svg.training-course-language-icon').forEach((element) => {
                this.updateLanguageCourse(element, false);
            });
        }
    }

    trainingCourseLanguageIconOnClickHandler(event) {
        console.debug(`[DEBUG] Invokved IllumioSupportTraining.LanguageCourse.trainingCourseLanguageIconOnClickHandler()`);
        console.debug(event);
        console.debug(event.target);
        console.debug(event.currentTarget);
        event.stopPropagation();

        this.updateLanguageCourse(event.currentTarget, true);
    }

    updateLanguageCourse(iconElement, isProcessDescriptionVisibility=false) {
        if (iconElement && iconElement.dataset.courseCode) {
            // Expand the description, if not already expanded
            const optionsElement = document.getElementById(`${iconElement.dataset.courseCode}_options`);
            if (isProcessDescriptionVisibility && optionsElement && (!optionsElement.style.display || optionsElement.style.display==='none')) {
                iconElement.parentElement.parentElement.click();
                iconElement.parentElement.parentElement.click(); 
            }

            // Loop through the icons and adjust the active/inactive class accordingly
            iconElement.parentElement.querySelectorAll('svg').forEach((element) => {
                if (element===iconElement) {
                    element.classList.add('active');
                    element.classList.remove('inactive');
                } else {
                    element.classList.remove('active');
                    element.classList.add('inactive');
                }
            });
            
            const selectedLanguageCode = iconElement.dataset.language;

            // Loop through the course description and display/hide the object accordingly
            optionsElement.querySelectorAll('.course_description').forEach((element) => {
                if (element.dataset.language===selectedLanguageCode) {
                    element.classList.remove('hidden');
                } else {
                    element.classList.add('hidden');
                }
            });
            
            // Loop through the 'View Self-Paced' and display/hide button accordingly
            optionsElement.querySelectorAll('.course-enroll-button').forEach((element) => {
                if (element.dataset.language===selectedLanguageCode) {
                    element.style.display = 'inline-flex';
                } else {
                    element.style.display = 'none';
                }
            });
        }
    }
};
